import React from 'react';

// eslint-disable-next-line no-unused-vars
export const ListContext = React.createContext<{ addReadId: (id: number, option?: { delay?: number; cb?: () => void, is_click?: boolean, is_read?: boolean }) => void; readIds: Set<number | string> }>({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  addReadId: () => { },
  readIds: new Set()
})